export default "__VITE_ASSET__Bc$HG8nf__"